import { Attach } from '../../composer-env';

const getValidAttachs = (attachs: Attach[]) =>
  attachs.filter(attach => attach.isValid);

export default getValidAttachs;
